<template>
  <div id="collections">
    <div class="box">
      <div class="title lv2Text">收藏的商品</div>
      <div v-if="empty==false">
        <el-row :gutter="40">
          <el-col :span="6" v-for="(item,index) of data" :key="index">
            <div class="item" @mouseenter="hoverFn(item.product_id)" @mouseleave="hoverId=null">
              <div
                class="lv3Text s"
                align="right"
                v-if="hoverId==item.product_id"
                @click="delFav(item.collect_id)"
              >
                <i style="z-index:20;font-size:20px" class="el-icon-close" ></i>
              </div>
              <router-link :to="'/view?id='+item.product_id">
                <el-image class="cover" :src="serve +item.images" fit="cover"></el-image>
              </router-link>
              <div class="lv2Text label" v-if="item.title">
                <router-link :to="'/view?id='+item.product_id">{{item.title.slice(0,10)}}</router-link>
              </div>
              <div class="price">&yen;{{item.selling_price}}</div>
              <div align="center" v-if="item.images">
                <router-link
                  :to="{ path: '/user/like', query: { id: item.product_id,name:item.title,price:item.selling_price,image:item.images.split(';')[0] }}"
                >
                  <el-button type="primary" size="small" class="like">查找相似</el-button>
                </router-link>
              </div>
            </div>
          </el-col>
        </el-row>
        <div class="pager" align="center">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="total"
            :page-size="12"
            @current-change="setPage"
            hide-on-single-page
          ></el-pagination>
        </div>
      </div>
      <div v-else class="empty lv4Text">
        <!-- <i class="fas fa-box-open fa-lg" style="margin-right:10px"></i>没有商品 -->
        <img style="margin:0 auto" :src="serve + '/image/none/none_img4.jpg'" alt="">
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      //
      serve: this.$store.state.serve,
      data: null,
      total: 0,
      page: 1,
      hoverId: null,
      empty: true
    };
  },
  activated() {
    this.$store.state.user_location = "收藏的商品";
  },
  created() {
    this.initData();
  },
  watch:{
    "$route":{
      handler(route){
        const that = this   
        if(route.name === 'collections/1'){
          that.initData();
        }
      },
      deep:true
    }
  },
  methods: {
    setPage(v) {
      this.page = v;
      this.initData();
    },
    delFav(id) {
      const loading = this.$loading({
        lock: true,
        spinner: "el-icon-loading",
        background: "rgba(255, 255, 255, 0.7)"
      });
      this.axios
        .get(this.serve + "/personal/del_collect", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            collect_ids: id
          }
        })
        .then(res => {
          if (res.data.status == "success") {
            loading.close();
            this.initData();
          }
        });
    },
    hoverFn(id) {
      this.hoverId = id;
    },
    initData() {
      this.axios
        .get(this.serve + "/personal/collect_list", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token"),
            page: this.page
          }
        })
        .then(res => {
          this.data = res.data.data.results;
          this.total = res.data.data.total;
          if (res.data.data.total > 0) {
            this.empty = false;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#collections {
  .empty {
    min-height: 500px;
    padding: 20px 0;
  }
  a {
    color: #606266;
  }
  .box {
    min-height: 600px;
    .s {
      z-index: 10;
      // float: right;
      position: absolute;
    }
    cursor: pointer;
    .s:hover {
      color: #e2211c;
    }
    .fa-trash-alt {
      margin: 20px;
    }
    background-color: #fff;
    border: 1px solid #ddd;
    padding: 40px;
    .item {
      border: 1px solid #ddd;
      margin-bottom: 20px;
      .label {
        text-align: center;
        padding: 10px 0;
      }
      .label:hover {
        text-decoration: underline;
      }
      .price {
        color: #e2211c;
        text-align: center;
        margin-bottom: 10px;
      }
      .like {
        margin-bottom: 10px;
      }
    }
    .cover {
      display: block;
      width: 180px;
      height: 180px;
      background-color: #eee;
      margin: 0 auto;
      margin-top: 10px;
      background-position: center;
      background-size: auto 100%;
      transition: 0.3s;
      cursor: pointer;
      background-repeat: no-repeat;
    }
    .cover:hover {
      background-size: auto 120%;
    }
    .title {
      margin: 20px 0;
      padding-bottom: 20px;
      border-bottom: 1px solid #ddd;
    }
  }
}
</style>